export default __webpack_public_path__ + "static/media/doctor-placeholder.88378592.svg";